// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProjectOutlinedSvg from "@ant-design/icons-svg/es/asn/ProjectOutlined";
import AntdIcon from '../components/AntdIcon';

var ProjectOutlined = function ProjectOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProjectOutlinedSvg
  }));
};

ProjectOutlined.displayName = 'ProjectOutlined';
export default React.forwardRef(ProjectOutlined);